import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/bundi.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from "react-helmet";

const Bundi = () => {
  return (
    <>
    <Helmet>
  <title>Discover Bundi: Rajasthan's Historical Marvels, Palaces, & Charming Festivities</title>

  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta name="description" content="Explore Bundi's rich historical legacy and vibrant life nestled amid the Aravalli hills. Unearth the glorious past through medieval forts, palaces, havelis, and temples adorned with intricate carvings and frescoes. Dive into Bundi's vibrant festivals, like the unique Kajli Teej, and witness its picturesque lakes, such as Nawal Sagar and Phool Sagar. Explore the grandeur of Bundi Palace, Chattar Mahal, and the exquisite Chitrashala. Unravel the treasures of Eighty Four Pillared Cenotaph, Rani Nathawati's Raniji ki Baori, and the impressive Taragarh Fort. Embark on a historical journey to Bijolia, Dugari, Indragarh, and Menal, witnessing their ancient forts, temples, and natural wonders. Discover the charm of Talwas' fort and Rameshwaram's cave temple. Bundi beckons with its historical marvels and scenic allure." />

  <meta name="keywords" content="Bundi, Rajasthan, historical marvels, palaces, Aravalli hills, forts, havelis, temples, festivals, Kajli Teej, Nawal Sagar, Phool Sagar, Bundi Palace, Chattar Mahal, Chitrashala, Eight Pillars Cenotaph, Raniji ki Baori, Taragarh Fort, Bijolia, Dugari, Indragarh, Menal, Talwas, Rameshwaram, cave temple" />

  <meta name="author" content="The Rustic Paths" />

  <meta property="og:title" content="Discover Bundi: Rajasthan's Historical Marvels, Palaces, & Charming Festivities" />
  <meta property="og:description" content="Explore Bundi's rich historical legacy and vibrant life nestled amid the Aravalli hills. Unearth the glorious past through medieval forts, palaces, havelis, and temples adorned with intricate carvings and frescoes. Dive into Bundi's vibrant festivals... (trimmed for brevity)" />
  <meta property="og:image" content={tour1} />

</Helmet>

      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Bundi</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Kajli Teej</li>
                      <li>Bundi Palace</li>
                      <li>Chattar Mahal or Palace of Towers</li>
                      <li>Chitrashala</li>
                      <li>Eighty Four Pillared Cenotaph</li>
                      <li>Kshar Bagh</li>
                      <li>Nawal Sagar</li>
                      <li>Phool Sagar</li>
                      <li>Raniji ki Baori</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Bikaner
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Surrounded by Aravalli hills on three sides and
                    circumscribed by a massive wall with four gateways is the
                    city of Bundi that is known for having a glorious past and a
                    promising future. Historical monuments, natural beauty,
                    scenic dams & ponds, wild forests fairs and festivity are
                    what symbolize life at this colorful city of Rajasthan. The
                    city of Bundi has interesting monuments including impressive
                    medieval forts, palaces, havelis, temples with beautiful
                    stone idols and 'chattris' with carved pillars, along with a
                    quaint lake in the heart of the town, adding to its charm.
                    Bundi is also famous for its intricate carvings and
                    frescoes.
                  </p>
                  <p>
                    Climate <br />
                    The weather in the district of Bundi is more on the hotter
                    side. During summers, the temperature goes up to 43'C while
                    that in winters, the temperature goes from 30'C to 5'C. The
                    coldest months witness temperature as low as 5'C. The
                    average rainfall here is around 75 cms annually.
                  </p>

                  <p>
                    Location <br />
                    Bundi district is located 36 kms from the Kota district of
                    Rajasthan. Tonk district lies in the north of Bundi while
                    Bhilwara and Chittorgarh touch the city on western and
                    southern extremes.
                  </p>

                  <p>
                    Bundi- History and Legends <br /> In the year 1193, when
                    Sultan Mohammed Ghauri defeated Prithvi Raj Chauhan, some
                    members of the Chauhan clan took shelter in Mewar and became
                    allies to the Rana there while the younger ones moved to the
                    Chambal valley and fought with Meena and Bhil tribals to
                    establish their kingdom of Hadoti. The city of Bundi was
                    then a part of the kingdom of Kota and was ruled by Hada
                    Chauhans who were the descendants of the famous Chauhan
                    dynasty. Later the two clans of Hada Chauhans formed two
                    separate states at Kota and Bundi, on either sides of the
                    river Chambal.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kajli Teej
                  </h2>

                  <p>
                    Although the festival of Teej is celebrated all over the
                    state of Rajasthan, Kajli Teej at Bundi is a lot different.
                    While in the rest of the state, it is celebrated on the
                    third day of Shravana, here at Bundi, it is celebrated on
                    the third day of Bhadra. A lot of tourists visit this place
                    during the festival to see the colors of Kajli Teej here.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bundi Palace
                  </h2>
                  <p>
                    Bundi palace is an ideal example of Rajput architecture and
                    has some wonderful frescoes.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Chattar Mahal or Palace of Towers
                  </h2>
                  <p>
                    The most attractive feature of the palace is the Hazari Pole
                    while one must also see Naubat Khana, Hathi Pole and the
                    Diwaan-e-Aam during his visit to the palace.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Chitrashala
                  </h2>
                  <p>
                    This palace is famous for elaborate colorful paintings on
                    the walls depicting scenes from Raasleela and the Raagmala.
                    It also has a fascinating pavilion and a gallery of
                    miniature frescoes.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Eighty Four Pillared Cenotaph
                  </h2>
                  <p>
                    Established by Rao Anirudh, this memorial has 84 pillars in
                    a single cenotaph and a Shivlinga.
                  </p>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kshar Bagh
                  </h2>
                  <p>
                    It is an ancient garden near the Shikar Burj with a
                    fascinating chatri and was visited by ancient rulers and
                    their families.
                  </p>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Nawal Sagar
                  </h2>
                  <p>
                    This lake, visible from the fort has a temple dedicated to
                    Varuna, the water god submerged into water at the center of
                    the lake. One can see the reflection of the fort and various
                    palaces of the city in this lake.
                  </p>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Phool Sagar
                  </h2>
                  <p>
                    The present residence of the former ruler, this palace has
                    an artificial tank and pictorial garden.
                  </p>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Raniji ki Baori
                  </h2>
                  <p>
                    Rani Nathawati constructed this 46 m deep well in the year
                    1699 AD. It has a superb gate and some beautiful carving.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Bundi;
